export function constructLogoStoragePath(companyId: string, operatingUnitId: string, extension: string) {
    return `companies/${companyId}/logos/${operatingUnitId}/logo${extension}`;
}